import React, {Component} from 'react';
import _ from 'lodash';


class InputSearch extends Component {
  constructor(props) {
    super(props);

    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnKeyUp = this.handleOnKeyUp.bind(this);
  }



  handleOnSubmit(){
    const {onSubmit} = this.props;
    if(onSubmit) onSubmit();
  }
  handleOnChange(e){
    
    this.props.onChange(e.target.value);
  }
  handleOnKeyUp(e){
    if(e.keyCode === 13){
      this.handleOnSubmit();
    }
  }


  render() {
    const {keyword} = this.props;

    return (
      <div className='input-container'>
        <input className='element' 
          onChange={this.handleOnChange} 
          onKeyUp={this.handleOnKeyUp}
          value={keyword} />
        <div className="button icon search" onClick={this.handleOnSubmit}></div>
      </div>
    );
  }
}

export default InputSearch;


// WEBPACK FOOTER //
// ./src/components/input/search.js